/**
 * Get configuration settings
 * @throws will throw an error if global const __CONFIG__ is undefined
 */
export default function getConfig(
  config?: Configuration | Record<string, never>
) {
  const _config = config || __CONFIG__;

  if (!_config) return {};

  return _config;
}
